import {lazy} from 'react'
import {Route, Switch} from 'react-router-dom'
import {Container} from '../../modules/components'

export enum TransactionRoutesEnum {
    DatatableHttpHistories = '/transacoes/logs',
    DatatableBatches = '/transacoes/em-lote',
    ShowBatch = '/transacoes/em-lote/:id',
    DatatablePix = '/transacoes/pix',
    DatatableCreditCard = '/transacoes/credito',
    DatatableDebitCard = '/transacoes/debito',
    DatatableRecurrents = '/transacoes/recorrentes',
    ShowTransaction = '/transacoes/:uuid',
}

export default function TransactionRouter() {
    const DatatableHttpHistories = lazy(
        () => import('../../pages/transactions/http_histories/DatatableHttpHistories')
    )
    const DatatableBatches = lazy(() => import('../../pages/transactions/batches/DatatableBatches'))
    const ShowBatch = lazy(() => import('../../pages/transactions/batches/ShowBatch'))
    const DatatablePix = lazy(() => import('../../pages/transactions/pix/DatatablePix'))
    const DatatableCreditCard = lazy(
        () => import('../../pages/transactions/credit/DatatableCreditCard')
    )
    const DatatableDebitCard = lazy(
        () => import('../../pages/transactions/debit/DatatableDebitCard')
    )
    const DatatableRecurrents = lazy(
        () => import('../../pages/transactions/recurrents/DatatableRecurrents')
    )
    const ShowTransaction = lazy(() => import('../../pages/transactions/show/ShowTransaction'))

    return (
        <Container loading={false}>
            <Switch>
                <Route
                    path={TransactionRoutesEnum.DatatableHttpHistories}
                    component={DatatableHttpHistories}
                />
                <Route path={TransactionRoutesEnum.ShowBatch} component={ShowBatch} />
                <Route path={TransactionRoutesEnum.DatatableBatches} component={DatatableBatches} />
                <Route path={TransactionRoutesEnum.DatatablePix} component={DatatablePix} />
                <Route
                    path={TransactionRoutesEnum.DatatableCreditCard}
                    component={DatatableCreditCard}
                />
                <Route
                    path={TransactionRoutesEnum.DatatableDebitCard}
                    component={DatatableDebitCard}
                />
                <Route
                    path={TransactionRoutesEnum.DatatableRecurrents}
                    component={DatatableRecurrents}
                />
                <Route path={TransactionRoutesEnum.ShowTransaction} component={ShowTransaction} />
            </Switch>
        </Container>
    )
}
